"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductCardBannerTypes = void 0;

require("core-js/modules/es6.array.map.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _currency = require("@nerdwallet/currency");

var _bestOfBadgeIcon = _interopRequireDefault(require("./best-of-badge-icon"));

var _productCardBannerModule = _interopRequireDefault(require("./product-card-banner.module.css"));

var ProductCardBannerTypes;
exports.ProductCardBannerTypes = ProductCardBannerTypes;

(function (ProductCardBannerTypes) {
  ProductCardBannerTypes[ProductCardBannerTypes["BestOf"] = 0] = "BestOf";
  ProductCardBannerTypes[ProductCardBannerTypes["Info"] = 1] = "Info";
  ProductCardBannerTypes[ProductCardBannerTypes["Warning"] = 2] = "Warning";
  ProductCardBannerTypes[ProductCardBannerTypes["Error"] = 3] = "Error";
  ProductCardBannerTypes[ProductCardBannerTypes["Success"] = 4] = "Success";
})(ProductCardBannerTypes || (exports.ProductCardBannerTypes = ProductCardBannerTypes = {}));

var ProductCardBanner = function ProductCardBanner(_ref) {
  var _ref5;

  var className = _ref.className,
      forceMobile = _ref.forceMobile,
      forceTablet = _ref.forceTablet,
      showV2Styles = _ref.showV2Styles,
      statusText = _ref.statusText,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? ProductCardBannerTypes.Warning : _ref$type;

  if (showV2Styles) {
    var _ref2, _ref3, _ref4;

    return /*#__PURE__*/_react.default.createElement(_currency.Box, {
      className: (0, _classnames.default)([(_ref2 = {}, (0, _defineProperty2.default)(_ref2, _productCardBannerModule.default.bannerV2Mobile, forceMobile || forceTablet), (0, _defineProperty2.default)(_ref2, _productCardBannerModule.default.bannerV2, !forceMobile && !forceTablet), _ref2)])
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)([(_ref3 = {}, (0, _defineProperty2.default)(_ref3, _productCardBannerModule.default.labelContainerMobile, forceMobile || forceTablet), (0, _defineProperty2.default)(_ref3, _productCardBannerModule.default.labelContainer, !forceMobile && !forceTablet), _ref3)])
    }, /*#__PURE__*/_react.default.createElement(_currency.Box, {
      className: (0, _classnames.default)([(_ref4 = {}, (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.bestOfV2, type === ProductCardBannerTypes.BestOf), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.infoV2, type === ProductCardBannerTypes.Info), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.warningV2, type === ProductCardBannerTypes.Warning), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.errorV2, type === ProductCardBannerTypes.Error), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.successV2, type === ProductCardBannerTypes.Success), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.bannerV2Wrap, !forceMobile && !forceTablet), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.labelDefault, !forceMobile && !forceTablet), (0, _defineProperty2.default)(_ref4, _productCardBannerModule.default.labelMobile, forceMobile || forceTablet), _ref4)])
    }, type === ProductCardBannerTypes.BestOf && /*#__PURE__*/_react.default.createElement(_bestOfBadgeIcon.default, {
      className: (0, _classnames.default)([_productCardBannerModule.default.bestOfBadgeV2, (0, _classes.default)('margin-right-2')])
    }), Array.isArray(text) ? /*#__PURE__*/_react.default.createElement("div", null, text.map(function (t) {
      return /*#__PURE__*/_react.default.createElement(_currency.Accent, {
        key: t,
        component: "p",
        size: "small",
        align: "left"
      }, t);
    })) : /*#__PURE__*/_react.default.createElement(_currency.Accent, {
      size: "small"
    }, text))));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([className, (0, _classes.default)('padding-horizontal-3'), (_ref5 = {}, (0, _defineProperty2.default)(_ref5, (0, _classes.default)('padding-horizontal-4--wide'), !forceMobile), (0, _defineProperty2.default)(_ref5, _productCardBannerModule.default.bestOf, type === ProductCardBannerTypes.BestOf), (0, _defineProperty2.default)(_ref5, _productCardBannerModule.default.info, type === ProductCardBannerTypes.Info), (0, _defineProperty2.default)(_ref5, _productCardBannerModule.default.warning, type === ProductCardBannerTypes.Warning), (0, _defineProperty2.default)(_ref5, _productCardBannerModule.default.error, type === ProductCardBannerTypes.Error), (0, _defineProperty2.default)(_ref5, _productCardBannerModule.default.success, type === ProductCardBannerTypes.Success), _ref5)])
  }, type === ProductCardBannerTypes.BestOf && /*#__PURE__*/_react.default.createElement(_bestOfBadgeIcon.default, {
    className: (0, _classnames.default)([_productCardBannerModule.default.bestOfBadge, (0, _classes.default)('margin-right-2')])
  }), statusText && /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small",
    bold: true
  }, statusText, ' '), Array.isArray(text) ? /*#__PURE__*/_react.default.createElement("div", null, text.map(function (t) {
    return /*#__PURE__*/_react.default.createElement(_currency.Text, {
      key: t,
      component: "p",
      size: "small"
    }, t);
  })) : /*#__PURE__*/_react.default.createElement(_currency.Text, {
    size: "small"
  }, text));
};

var _default = ProductCardBanner;
exports.default = _default;